import { render } from "./usable_point.vue?vue&type=template&id=b832b594"
import script from "./usable_point.vue?vue&type=script&lang=js"
export * from "./usable_point.vue?vue&type=script&lang=js"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__